module.exports = __webpack_public_path__ + "static/489150096.448b2996.jpg";